module.exports = {
	"apiurl": "http://kleppeter.uahnn.com/api",
	"spotifyurl": "",
	"appurl": "http://app.klappater.uahnn.com/#/",
	"facebook_id": 301006706977265
};


//////////////////
// WEBPACK FOOTER
// ./src/conf.json
// module id = 10
// module chunks = 1